export enum PanelType {
  OuterPanel = 0,
  TrayPanel = 1,
  RollerBoard = 2,
  Underlay = 3,
  SlideRail = 4,
}
